import { render, staticRenderFns } from "./LinkTab.vue?vue&type=template&id=7d80d580&scoped=true"
import script from "./LinkTab.vue?vue&type=script&lang=js"
export * from "./LinkTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80d580",
  null
  
)

export default component.exports